/*
  FINAL REFINED HEADER COMPONENT (Reference Logic)
  - Logo on left, Toggle on right of a fixed-width branding container.
  - No static branding text (Image only).
  - High visibility Heroicons for toggle.
*/

import { Link } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import LoginLogo from "../assets/images/LoginLogo.jpg";
import { Button } from "primereact/button";

const Header = ({ openMenu, setOpenMenu }) => {
  const handleToggle = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <div className="bg-white px-4 py-2 flex items-center justify-between sticky top-0 w-full  h-20 shadow-md z-[9999] ">
      {/* header left side - Logo & Toggle in a fixed-width container matching Sidebar */}
      <div className="flex gap-36 md:gap-32 items-center w-full">
        {/* logo of the project company */}
        <Link to="/" className="flex items-center">
          <img src={LoginLogo} alt="logo" className="py-3 h-[90px]" />
        </Link>

        {/* icon for menu expand and collapse - Placed on the RIGHT side of the branding area */}
        <Button
          onClick={handleToggle}
          className="p-1.5 hover:bg-gray-100 rounded-md border-stone-400 border cursor-pointer transition-all flex items-center justify-center h-9 w-9 shadow-sm "
        >
          {openMenu ? (
            <XMarkIcon className="h-6 w-6 text-gray-900 stroke-[2.5px]" />
          ) : (
            <Bars3Icon className="h-6 w-6 text-gray-900 stroke-[2.5px]" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default Header;
